import { render, staticRenderFns } from "./TeamsportPlayoffTree.vue?vue&type=template&id=7bf938df&scoped=true"
import script from "./TeamsportPlayoffTree.vue?vue&type=script&lang=js"
export * from "./TeamsportPlayoffTree.vue?vue&type=script&lang=js"
import style0 from "./TeamsportPlayoffTree.vue?vue&type=style&index=0&id=7bf938df&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bf938df",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VAlert,VProgressCircular})
